var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chooser"},[_c('div',{staticClass:"navbar"},_vm._l((this.routes),function(route,index){return _c('button',{key:route.id,staticClass:"switch",class:{ switch_active: _vm.activeRoute == index },on:{"click":function($event){return _vm.onClick(index, route.cb)}}},[_c('span',[_vm._v(_vm._s(route.text))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }